import { MegaMenuNavigation } from "../../../../modules/content/components/MegaMenuNavigation/MegaMenuNavigation";
import type { IMegaMenuBlockProps } from "./MegaMenuBlock.props";

export const MegaMenuBlock = (props: IMegaMenuBlockProps) => <MegaMenuNavigation {...props} />;
MegaMenuBlock.displayName = "Block::MegaMenuBlock";
